import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Route } from '../../Types';
import { Breadcrumbs } from '../Breadcrumbs';
import styles from './page-wrapper.module.css';

interface PageWrapperProps {
    children: React.ReactNode;
    breadCrumbs?: {
        current: string;
        routes: Route[];
    };
    className?: string;
    pageTitle?: string;
}

// eslint-disable-next-line import/prefer-default-export
export const PageWrapper: React.FC<PageWrapperProps> = ({ children, breadCrumbs, className, pageTitle }) => (
    <>
        {!!breadCrumbs && breadCrumbs.current && breadCrumbs.routes && (
            <div className={styles.PageWrapperBreadcrumbs}>
                <Breadcrumbs current={breadCrumbs.current} routes={breadCrumbs.routes} />
            </div>
        )}
        <Helmet>
            <title>{pageTitle || 'Tenant'}</title>
        </Helmet>
        <div className={`${styles.PageWrapper} ${className || ''}`} data-qa="page-wrapper">
            {children}
        </div>
    </>
);
